import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddHomework from "../../../containers/admin/homework/models/add-homework";
import DeleteHomework from "../../../containers/admin/homework/models/delete-homework";
import SearchBar from "../../../containers/admin/homework/searchbar";
import HomeworkTable from "../../../containers/admin/homework/table";

import AddHomeworkExamData from "../../../containers/admin/homework/models/add-exam-data";
import {
  getAllHomeworksRequest,
  getStudentHomeworkQuizRequest,
} from "../../../modules/admin-modules/homework/Actions";

const Homeworks = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllHomeworksRequest());
    dispatch(getStudentHomeworkQuizRequest());
  }, []);
  return (
    <Layout>
      <SearchBar setAdd={setAdd} />
      <AddHomework
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />

      <AddHomeworkExamData
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />

      <HomeworkTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <DeleteHomework data={selectedData} />
    </Layout>
  );
};

export default Homeworks;
